<template>
    <ui-feed-card :class="typeClassComputed">
        <template #header>
            <div class="points">
                <div v-if="data.value" class="current">{{ valueComputed }}</div>
                <div v-if="data.used" class="remaining">{{ usedComputed }}</div>
            </div>
            <div v-if="data.type" class="tag" :class="data.type">{{ typeComputed }}</div>
        </template>

        <div>
            <div v-if="data.observations" class="observations">{{ data.observations }}</div>
            <div v-else>-</div>
        </div>

        <template #footer>
            <div v-if="createdComputed" class="start-date">Cadastro em: {{ createdComputed }}</div>
            <ui-tag-indicator
                v-if="validateComputed"
                :color="validateColorComputed"
                :text-size="10"
                :text="validateComputed"
            />
        </template>
    </ui-feed-card>
</template>

<script>
	import { uiFeedCard 	} from '@/components/ui'
	import { uiTagIndicator } from '@/components/ui/tags'
	const moment = require('moment')
	require('moment/locale/pt-br')

	export default {
		name: 'ui-points-feed-card',
		components: {
			uiFeedCard,
			uiTagIndicator,
		},

		props: {
			data: {
				type: Object,
				required: true,
				default: function () {
					return {}
				},
			},
		},

		data() {
			return {}
		},

		computed: {
			/**
			 * Data que foi adicionado o ponto
			 */
			createdComputed() {
				return moment(this.data.created_at).format('DD/MM/YYYY')
			},

			/**
			 * Quantidade de pontos
			 * É tratado para que receba o plural de acordo com a quantidade
			 */
			valueComputed() {
				let type = this.data.type.toLowerCase() === 'debit' ? '-' : '+'
				let quantity = Number(this.data.value) <= 1 ? '' : 's'
				return `${type}${this.data.value} ponto${quantity}`
			},

			/**
			 * Pontos  já usados
			 * É tratado para que receba o plural de acordo com a quantidade
			 */
			usedComputed() {
				let quantity = Number(this.data.used) <= 1 ? '' : 's'
				return `${this.data.used} ponto${quantity} restante${quantity}`
			},

			/**
			 * Tipo de ponto
			 * É tratado para ser impresso em português
			 */
			typeComputed() {
				return this.data.type.toLowerCase() === 'debit' ? 'Débito' : 'Crédito'
			},

			/**
			 * Tipo de ponto
			 * Usado para definir as cores usadas no card de pontos
			 * se credit verde
			 * se debit vermelho
			 */
			typeClassComputed() {
				return this.data.type.toLowerCase()
			},

			/**
			 * Data de expiração/validade do ponto
			 * É tratado para que apareça no formato PT-br
			 */
			validateComputed() {
				return 'Expira em: ' + moment(this.data.validate).format('DD/MM/YYYY')
			},

			/**
			 * Data de expiração
			 * Verifica se a data de expiração já passou
			 * se não passou a cor é verde
			 * se já passou a cor é amarela
			 */
			validateColorComputed() {
				return moment(new Date()).isBefore(this.data.validate) ? '#5ac387' : '#f1c40f'
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
